import React, { ReactNode } from "react";
import { Paper, Box } from "@mui/material";
import AppTableContainer from "./AppTableContainer";
import AppTable from "./AppTable";
import AppTableHead from "./AppTableHead";
import AppTableBody from "./AppTableBody";
const AppTableLayoutSkeleton = ({
  children,
  header,
}: AppTableLayoutSkeletonProps) => {
  return (
    <>
      <Paper
        sx={{
          overflow: "hidden",
          boxShadow: "unset",
          position: "relative",
          borderRadius: "12px 12px 0 0",
          backgroundColor: "transparent",
          height: "100%",
        }}
      >
        <AppTableContainer id="table" className="h-full">
          <Box
            sx={{
              paddingBottom: "20px",
            }}
          >
            <AppTable
              sx={{
                borderLeft: "1px solid #eee",
                borderRight: "1px solid #eee",
              }}
            >
              <AppTableHead>{header}</AppTableHead>
              <AppTableBody
                sx={{
                  backgroundColor: "common.white",
                }}
              ></AppTableBody>
            </AppTable>
            {children}
          </Box>
        </AppTableContainer>
      </Paper>
    </>
  );
};

export type AppTableLayoutSkeletonProps = {
  header?: ReactNode;
  children: ReactNode;
};

export default AppTableLayoutSkeleton;
